import { Component, input, Input } from '@angular/core';
import { ICardField } from 'src/app/models/viewModels/cardModel';

@Component({
  selector: 'app-carousel-card',
  templateUrl: './carousel-card.component.html',
  styleUrls: ['./carousel-card.component.scss'],
})
export class CarouselCardComponent {
  @Input() public titleLabelPath: string;
  @Input() public cardFieldsList: ICardField[][];
  @Input() public titleTooltipLabelPath: string;
  public isToggleContentAllowed = input<boolean>(false);

  public index = 0;

  public prevItem() {
    this.index = (this.cardFieldsList.length + this.index - 1) % this.cardFieldsList.length;
  }

  public nextItem() {
    this.index = (this.index + 1) % this.cardFieldsList.length;
  }
}
